

export default function () {
    return "access forbidden";
}